import { Link } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const COLS = [
  {
    title: "Shop",
    links: [
      { label: "All products", to: "/shop" },
      { label: "Wireless Lavalier", to: "/shop?category=wireless-lavalier" },
      { label: "USB-C Microphones", to: "/shop?category=usb-c-microphones" },
      { label: "Lightning Microphones", to: "/shop?category=lightning-microphones" },
      { label: "Bundles", to: "/shop?category=creator-bundles" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About us", to: "/about" },
      { label: "Blog", to: "/blog" },
      { label: "Contact", to: "/contact" },
      { label: "Support", to: "/support" },
    ],
  },
  {
    title: "Help",
    links: [
      { label: "Track order", to: "/track" },
      { label: "FAQ", to: "/faq" },
      { label: "Shipping policy", to: "/shipping-policy" },
      { label: "Returns & refunds", to: "/refund-policy" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy policy", to: "/privacy-policy" },
      { label: "Terms of service", to: "/terms-of-service" },
    ],
  },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/subscribe", { email });
      toast.success("You are on the list — welcome to CreatorMic Pro.");
      setEmail("");
    } catch (err) {
      toast.error("Could not subscribe. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-[#F5F5F7] border-t border-black/5 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid md:grid-cols-2 gap-10 pb-14 border-b border-black/5">
          <div>
            <h3 className="text-h3 text-[#1D1D1F] max-w-md">Get product drops, tutorials, and gear guides in your inbox.</h3>
            <p className="mt-3 text-[#86868B] text-sm">No spam. Unsubscribe anytime.</p>
          </div>
          <form onSubmit={subscribe} className="flex gap-2 items-end" data-testid="footer-subscribe-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@creator.com"
              data-testid="footer-subscribe-email"
              className="flex-1 h-12 px-4 rounded-xl bg-white border border-transparent focus:border-[#0066FF] focus:ring-1 focus:ring-[#0066FF] focus:outline-none"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="footer-subscribe-submit"
              className="btn-primary h-12 disabled:opacity-60"
            >
              {loading ? "Subscribing..." : "Subscribe"}
            </button>
          </form>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mt-14">
          {COLS.map((c) => (
            <div key={c.title}>
              <p className="eyebrow mb-4">{c.title}</p>
              <ul className="space-y-3">
                {c.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="text-sm text-[#1D1D1F] hover:text-[#0066FF] transition-colors">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-black/5 flex flex-col md:flex-row justify-between gap-4">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-full bg-[#0066FF] grid place-items-center text-white font-black text-xs">C</div>
            <span className="font-display font-bold text-[#1D1D1F]">CreatorMic Pro</span>
            <span className="text-sm text-[#86868B] ml-2">Operated by CLSX LLC</span>
          </div>
          <p className="text-sm text-[#86868B]">© {new Date().getFullYear()} CreatorMic Pro. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
